import { render, staticRenderFns } from "./TwoFactorAuthModal.vue?vue&type=template&id=0a407e5e&scoped=true"
import script from "./TwoFactorAuthModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthModal.vue?vue&type=style&index=0&id=0a407e5e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a407e5e",
  null
  
)

export default component.exports